import { useMemo } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { OrderType } from "tm-shared/types";

import {
    useCheckoutCompletedSelector,
    useCheckoutSelector,
} from "@/hooks/redux";
import NotFound from "@/pages/System/NotFound";

import { OrderDetailsPage } from "./OrderDetailsPage";

export const ORDER_TYPES_WITH_DISABLED_CHANGES = [OrderType.P, OrderType.R];

function OrderDetails() {
    const [searchParams] = useSearchParams();
    const { orderId = "" } = useParams<{ orderId: string }>();

    // --- URL-derived state ---
    const isOrderClosed = useMemo(
        () => searchParams.get("isClosed")?.split("-")?.[0] === "true",
        [searchParams],
    );

    // --- Order state ---
    const orderNotCompleted = useCheckoutSelector(orderId);
    const orderCompleted = useCheckoutCompletedSelector(orderId);

    const order = useMemo(
        () => (isOrderClosed ? orderCompleted : orderNotCompleted),
        [isOrderClosed, orderCompleted, orderNotCompleted],
    );

    if (!order) return <NotFound />;

    return <OrderDetailsPage order={order} />;
}

export default OrderDetails;
